import {
	Checkbox,
	List,
	ListItem,
	ListItemButton,
	ListItemIcon,
	ListItemText,
} from '@mui/material';

import { Box } from '@mui/system';
import { useEffect, useState } from 'react';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';

const SamplesFilter = (props) => {
	const [checked, setChecked] = useState(0);

	const handleToggle = (value) => {
		if (value !== checked) {
			setChecked(value);
			props.onFilterChange(props.filters[value]);
		}
	};
	const [isMobile, setIsMobile] = useState(window.innerWidth <= 900);
	useEffect(() => {
		function handleResize() {
			setIsMobile(window.innerWidth <= 900);
		}
		window.addEventListener('resize', handleResize);
		return (_) => {
			window.removeEventListener('resize', handleResize);
		};
	});

	return (
		<Box>
			<List className='filters-list' sx={{ padding: 0, width: '100%' }} dense>
				{props.filters.map((f, idx) => {
					const labelId = `checkbox-list-label-${idx}`;
					return (
						<ListItem
							sx={{
								height: isMobile ? '45px' : '40px',
								border: '1px #C6C2C2 solid',
								backgroundColor: checked === idx ? '#22294D' : '',
								color: checked === idx ? '#fff' : '#22294D',
							}}
							key={idx}
							disablePadding
						>
							<ListItemButton
								role={undefined}
								onClick={handleToggle.bind(this, idx)}
								dense
							>
								<ListItemIcon>
									<Checkbox
										icon={
											<RadioButtonUncheckedIcon sx={{ color: '#22294D' }} />
										}
										checkedIcon={
											<RadioButtonCheckedIcon sx={{ color: '#fff' }} />
										}
										edge='start'
										checked={checked === idx}
										tabIndex={-1}
										disableRipple
										inputProps={{ 'aria-labelledby': labelId }}
									/>
								</ListItemIcon>
								<ListItemText id={labelId} primary={f} />
							</ListItemButton>
						</ListItem>
					);
				})}
			</List>
		</Box>
	);
};

export default SamplesFilter;
